import type { IconProps } from "../Icon.props";
import createWebIcon from "../createWebIcon";
import validateKeys from "../validateKeys";

export default function Chart2({ outline, ...props }: IconProps): JSX.Element {
  return outline ? <Chart2.Outline {...props} /> : <Chart2.Solid {...props} />;
}

Chart2.Outline = function Outline({ name, ...props }: IconProps) {
  const Icon = createWebIcon({
    ...props,
    name: `${name}Outline`,
    path: (
      <>
        {/**
         * Enter the contents of your SVG here without the <svg> tag.
         * For outlined icons, be sure to add `className="icon-outline"`
         * to each path that needs to be outlined.
         */}
      </>
    ),
  });

  return <Icon {...validateKeys(props)} />;
};

Chart2.Solid = function Solid({ name, ...props }: IconProps) {
  const Icon = createWebIcon({
    ...props,
    name: `${name}Solid`,
    path: (
      <>
        <path
          opacity="0.4"
          fillRule="evenodd"
          clipRule="evenodd"
          d="M15.2428 4.73756C15.2428 6.95855 17.0459 8.75902 19.2702 8.75902C19.5151 8.75782 19.7594 8.73431 20 8.68878V16.6615C20 20.0156 18.0215 22 14.6624 22H7.34636C3.97851 22 2 20.0156 2 16.6615V9.3561C2 6.00195 3.97851 4 7.34636 4H15.3131C15.2659 4.243 15.2423 4.49001 15.2428 4.73756ZM13.15 14.8966L16.0078 11.2088V11.1912C16.2525 10.8625 16.1901 10.3989 15.8671 10.1463C15.7108 10.0257 15.5122 9.97345 15.3167 10.0016C15.1211 10.0297 14.9453 10.1358 14.8295 10.2956L12.4201 13.3951L9.6766 11.2351C9.51997 11.1131 9.32071 11.0592 9.12381 11.0856C8.92691 11.1121 8.74898 11.2166 8.63019 11.3756L5.67562 15.1863C5.57177 15.3158 5.51586 15.4771 5.51734 15.6429C5.5002 15.9781 5.71187 16.2826 6.03238 16.3838C6.35288 16.485 6.70138 16.3573 6.88031 16.0732L9.35125 12.8771L12.0948 15.0283C12.2508 15.1541 12.4514 15.2111 12.6504 15.1863C12.8494 15.1615 13.0297 15.0569 13.15 14.8966Z"
          className="icon-secondary"
        />
        <path
          d="M16.008 11.2088L13.1502 14.8966C13.03 15.0569 12.8496 15.1615 12.6506 15.1863C12.4516 15.2111 12.251 15.1541 12.095 15.0283L9.35147 12.8771L6.88054 16.0732C6.70161 16.3573 6.35311 16.485 6.03261 16.3838C5.7121 16.2826 5.50043 15.9781 5.51757 15.6429C5.51609 15.4771 5.572 15.3158 5.67585 15.1863L8.63042 11.3756C8.74921 11.2166 8.92714 11.1121 9.12404 11.0857C9.32094 11.0592 9.52019 11.1131 9.67683 11.2351L12.4204 13.3951L14.8297 10.2956C14.9456 10.1358 15.1213 10.0297 15.3169 10.0016C15.5124 9.97346 15.711 10.0257 15.8674 10.1463C16.1903 10.3989 16.2527 10.8625 16.008 11.1912V11.2088Z"
          className="icon-primary"
        />
        <circle cx="19.5" cy="4.5" r="2.5" className="icon-primary" />
      </>
    ),
  });

  return <Icon {...validateKeys(props)} />;
};
